/**
 * 当前自身的状态是否需要 独立出来 ？
 */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { UserInfoItem, WeMeetClient } from '@tencent/wemeet-websdk-next';
import type { AppState } from '../index';

// slice state 类型定义
interface UserStoreState {
  userList: UserInfoItem[];

  // 自身的一些 ID 信息
  // 目前只存了加入XMPP 会议成功后返回的数据
  selfUserMetaInfo: SelfUserMetaInfo;
}
interface SelfUserMetaInfo {
  av_identifier: string; // 这个就是 openId
  av_user_id: string; // tinyId，给到媒体后台
  av_room_id: string; // 媒体房间 ID
}

// 初始状态
const initialState: UserStoreState = {
  userList: [],

  selfUserMetaInfo: {
    av_identifier: '',
    av_user_id: '',
    av_room_id: '',
  },
};

export const authenticationSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserList: (state, action) => {
      const userList = action.payload;
      state.userList = [...userList];
    },
    setSelfUserMetaInfo: (state, action: PayloadAction<SelfUserMetaInfo>) => {
      state.selfUserMetaInfo = {
        ...state.selfUserMetaInfo,
        ...action.payload,
      };
    },
  },
});

export const getSelfUserMetaInfo = (state: AppState) => state.user.selfUserMetaInfo;

export const { setUserList, setSelfUserMetaInfo } = authenticationSlice.actions;

/**
 * 获取用户列表（未排序）的 selecter
 */
export const getUserList = (state: AppState) => state.user.userList;

/**
 * 获取个人信息
 */
export const getSelfInfo = (state: AppState) => WeMeetClient.utils.getSelfUserInfo(state.user.userList);

export default authenticationSlice.reducer;
